import { ActivatedRoute } from '@angular/router';
import { EventService } from '../../Services/event.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-meerdaagse-list',
  template: require('./meerdaagse-list.component.html'),
  styles: [require('./meerdaagse-list.component.css')]
})
export class MeerdaagseListComponent implements OnInit {
  events: any = [];
  eventType: number = 0;
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private eventService: EventService,
    private auth: AuthService) {

    route.params.subscribe(p => {
      if (p['id'])
        this.eventType = +p['id'];
      else
        this.eventType = 0;
    });

  }

  ngOnInit() {
    this.loading = true;
    this.eventService.getAllEventsByType(this.eventType).subscribe(res => {
      this.events = res;
      // console.log(res);
      this.loading = false;
    });
  }

  switchVisible(id: number, visible: boolean) {
    // console.log("id: "+id+" clicked");

    this.eventService.changeVisible(id, visible).subscribe(res => {
      if (res == 200) {
        var ev = this.events.find((e: any) => e.id == id)
        ev.isVisible = !visible
      }
    })

  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/meerdaagse-list/meerdaagse-list.component.ts